import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import './Belt.css';

const Belt = ({ className, children }) => (
  <div className={classNames('belt', className)}>
    {children}
  </div>
);

Belt.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
};

export default Belt;



// WEBPACK FOOTER //
// ./src/components/Belt/Belt.jsx